import { useIsArtefactEditable } from '@modules/common/hooks';
import { DashboardRow } from '@modules/dashboard/components/Layout/DashboardRow';
import { DashboardRowResizer } from '@modules/dashboard/components/Layout/DashboardRowResizer';
import { DashboardState } from '@modules/dashboard/store/types';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { Box } from '@mui/material';

interface LayoutProps {
  shouldDisableInteraction?: boolean;
  onResizeEnd: (metadata: DashboardState['metadata']) => void;
}

export function Layout({
  onResizeEnd,
  shouldDisableInteraction = false,
}: LayoutProps) {
  const rows = useDashboardStore(({ metadata }) => metadata.layout.rows);
  const editToken = useDashboardStore(({ dashboard }) => dashboard.editToken);
  const status = useDashboardStore(({ dashboard }) => dashboard.status);

  const isEditable = useIsArtefactEditable({
    editToken,
    status,
  });

  return (
    <Box sx={{ mb: 12 }}>
      {rows.length && isEditable && !shouldDisableInteraction ? (
        <DashboardRowResizer
          row={rows[0]}
          shouldAddAtTheTop={true}
          shouldAlwaysShowLine
          isResizable={false}
          shouldAllowAddContent
          shouldAllowDrop={false}
        />
      ) : (
        <Box sx={{ height: '20px', width: '100%' }} />
      )}
      {rows.map((row) => {
        return (
          <DashboardRow
            key={row.id}
            row={row}
            onResizeEnd={onResizeEnd}
            shouldDisableInteraction={!isEditable}
          />
        );
      })}
    </Box>
  );
}
